import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * SiteSelectionForm (Step 1) - Redirects to Step 2
 *
 * Step 1 (site selection) is no longer directly accessible.
 * Sites are now selected from the Sites page before creating a visit request.
 * If a user navigates to step 1, they are automatically redirected to step 2.
 */
const SiteSelectionForm: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        // Step 1 is not accessible - redirect to step 2
        if (id) {
            navigate(`/visitor-request/${id}/step/2`, { replace: true });
        } else {
            navigate('/sites', { replace: true });
        }
    }, [id, navigate]);

    // Return null while redirecting
    return null;
};

export default SiteSelectionForm;
